module.exports = __webpack_public_path__ + "img/11.55c5621a.jpg";